(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["aw-cart-drawer"]) return;
  try {
    
  const parseAwCartDrawerDateTime = (value) => {
    const normalizedValue = value.trim();

    if (!normalizedValue) {
      return null;
    }

    const match = normalizedValue.match(/^(\d{4})\/(\d{2})\/(\d{2})\s+(\d{2}):(\d{2})$/);

    if (!match) {
      return false;
    }

    const [, year, month, day, hour, minute] = match;
    const parsedDate = new Date(
      Number(year),
      Number(month) - 1,
      Number(day),
      Number(hour),
      Number(minute),
      0,
      0
    );

    if (Number.isNaN(parsedDate.getTime())) {
      return false;
    }

    return parsedDate;
  };

  const syncAwCartDrawerGiftWrappingVisibility = (root = document) => {
    root.querySelectorAll("[data-aw-gift-wrapping-period]").forEach((element) => {
      const startAtRaw = element.dataset.startAt || "";
      const endAtRaw = element.dataset.endAt || "";
      const startAt = parseAwCartDrawerDateTime(startAtRaw);
      const endAt = parseAwCartDrawerDateTime(endAtRaw);
      const hasStartAt = startAtRaw.trim() !== "";
      const hasEndAt = endAtRaw.trim() !== "";

      if ((hasStartAt && startAt === false) || (hasEndAt && endAt === false)) {
        element.hidden = true;
        return;
      }

      const now = new Date();
      const isAfterStart = !startAt || now >= startAt;
      const isBeforeEnd = !endAt || now <= endAt;

      element.hidden = !(isAfterStart && isBeforeEnd);
    });
  };

  if (!window.awCartDrawerGiftWrappingPeriodInitialized) {
    window.awCartDrawerGiftWrappingPeriodInitialized = true;

    document.addEventListener("cart-drawer:refreshed", (event) => {
      syncAwCartDrawerGiftWrappingVisibility(event.target);
    });

    document.addEventListener("shopify:section:load", (event) => {
      syncAwCartDrawerGiftWrappingVisibility(event.target);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => syncAwCartDrawerGiftWrappingVisibility());
  } else {
    syncAwCartDrawerGiftWrappingVisibility();
  }

  } catch(e) { console.error(e); }
})();
})();
